import { Converter } from '../types/converter';

export const heatTransferCoefficientConverter: Converter = {
  id: 'heatTransferCoefficient',
  name: 'Heat Transfer Coefficient Converter',
  icon: 'Thermometer',
  categories: ['engineering', 'heat'],
  units: [
    // Base SI unit
    { name: 'Watt/Square Meter/K', symbol: 'W/(m²·K)', factor: 1 },
    { name: 'Watt/Square Meter/°C', symbol: 'W/(m²·°C)', factor: 1 },
    { name: 'Joule/Second/Square Meter/K', symbol: 'J/(s·m²·K)', factor: 1 },
    
    // Calorie-based units
    { name: 'Calorie (IT)/Second/Square Centimeter/°C', symbol: 'cal (IT)/(s·cm²·°C)', factor: 41868 },
    { name: 'Kilocalorie (IT)/Hour/Square Meter/°C', symbol: 'kcal (IT)/(h·m²·°C)', factor: 1.163 },
    { name: 'Kilocalorie (IT)/Hour/Square Foot/°C', symbol: 'kcal (IT)/(h·ft²·°C)', factor: 0.1080486 },
    
    // BTU-based units
    { name: 'Btu (IT)/Second/Square Foot/°F', symbol: 'Btu (IT)/(s·ft²·°F)', factor: 20441.754 },
    { name: 'Btu (th)/Second/Square Foot/°F', symbol: 'Btu (th)/(s·ft²·°F)', factor: 20428.074 },
    { name: 'Btu (IT)/Hour/Square Foot/°F', symbol: 'Btu (IT)/(h·ft²·°F)', factor: 5.678263 },
    { name: 'Btu (th)/Hour/Square Foot/°F', symbol: 'Btu (th)/(h·ft²·°F)', factor: 5.674465 },
    
    // CHU unit
    { name: 'CHU/Hour/Square Foot/°C', symbol: 'CHU/(h·ft²·°C)', factor: 10.221 }
  ]
};
